import { useCallback } from "react";
import { apiRequest } from "./MsalConfig";
import { useAccessToken } from "./useAccessToken";

export const useApiToken = () => {
  const getToken = useAccessToken();
  return useCallback(() => getToken(apiRequest.scopes), [getToken]);
};
